module.exports = { "default": require("core-js/library/fn/object/get-own-property-names"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/.6.26.0@babel-runtime/core-js/object/get-own-property-names.js
// module id = 82
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///~/.6.26.0@babel-runtime/core-js/object/get-own-property-names.js